// components/icons/FolderIcon.tsx
import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
  }


const FolderIcon: React.FC<IconProps> = ({className, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            className={className}
            {...props} // Spread additional props for flexibility
        >
            <path
                d="M1 10.5489V9.8566C1 9.30576 1.21882 8.77749 1.60832 8.38799C1.99782 7.99849 2.52609 7.77967 3.07692 7.77967H16.9231C17.4739 7.77967 18.0022 7.99849 18.3917 8.38799C18.7812 8.77749 19 9.30576 19 9.8566V10.5489M10.9785 4.60429L9.02154 2.64736C8.89298 2.51864 8.74031 2.41652 8.57226 2.34683C8.40421 2.27714 8.22408 2.24125 8.04215 2.24121H3.07692C2.52609 2.24121 1.99782 2.46003 1.60832 2.84953C1.21882 3.23903 1 3.7673 1 4.31813V15.3951C1 15.9459 1.21882 16.4742 1.60832 16.8637C1.99782 17.2532 2.52609 17.472 3.07692 17.472H16.9231C17.4739 17.472 18.0022 17.2532 18.3917 16.8637C18.7812 16.4742 19 15.9459 19 15.3951V7.08736C19 6.53653 18.7812 6.00826 18.3917 5.61876C18.0022 5.22926 17.4739 5.01044 16.9231 5.01044H11.9578C11.5907 5.01012 11.2379 4.86403 10.9785 4.60429Z"
                stroke="currentColor"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default FolderIcon;
